/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import { makeStyles } from '@material-ui/core/styles';
import MuiFade from '@material-ui/core/Fade';
import MuiTooltip from '@material-ui/core/Tooltip';
import useResponsive from 'hooks/useResponsive';

const useStyles = (light) => makeStyles((theme) => {
  let tooltip = {
    padding: '8px 12px',
    borderRadius: '6px',
    fontSize: '14px',
    lineHeight: '22px',
    letterSpacing: '0.014px',
    boxShadow: '1px 1.5px 1.5px 0px rgba(0, 0, 0, 0.10)',
    color: 'var(--color-white)',
    backgroundColor: 'var(--color-night-gray9)',
  };

  let arrow = {
    color: 'var(--color-night-gray9)',
    transform: 'scale(2)',
    '&::before': {
      boxShadow: '1px 1.5px 1.5px 0px rgba(0, 0, 0, 0.10)',
      borderRadius: '1px',
    },
  };

  if (light) {
    tooltip = {
      ...tooltip,
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
    };

    arrow = {
      ...arrow,
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
    };
  }
  return { tooltip, arrow };
});

const Tooltip = ({
  light,
  enterDelay,
  innerRef,
  content,
  inheritStyle,
  placement,
  preventOverflowOnViewport,
  children,
  ...otherProps
}) => {
  const classes = useStyles(light)();
  const isMobile = useResponsive();

  if (!content) {
    return (
      <div ref={innerRef} style={{ display: inheritStyle ? 'inherit' : null }} {...otherProps}>
        { children }
      </div>
    );
  }

  return (
    <MuiTooltip
      arrow
      classes={classes}
      enterDelay={enterDelay}
      enterNextDelay={100}
      TransitionComponent={MuiFade}
      TransitionProps={{ timeout: 200 }}
      title={content}
      placement={isMobile ? 'bottom' : placement}
    >
      <div
        ref={innerRef}
        style={{ display: inheritStyle ? 'inherit' : null, position: 'relative' }}
        {...otherProps}
      >
        { children }
      </div>
    </MuiTooltip>
  );
};

Tooltip.propTypes = {
  light: PropTypes.bool,
  enterDelay: PropTypes.number,
  children: PropTypes.node.isRequired,
  content: PropTypes.node,
  inheritStyle: PropTypes.bool,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  placement: PropTypes.oneOf([
    'bottom-end', 'bottom-start', 'bottom',
    'left-end', 'left-start', 'left',
    'right-end', 'right-start', 'right',
    'top-end', 'top-start', 'top',
  ]),
  preventOverflowOnViewport: PropTypes.bool,
};

Tooltip.defaultProps = {
  light: false,
  content: null,
  enterDelay: 200,
  innerRef: null,
  inheritStyle: true,
  placement: 'top',
  preventOverflowOnViewport: false,
};

export default React.memo(Tooltip);



// WEBPACK FOOTER //
// ./components/core/Tooltip.js